import { useState } from 'react';
import { navItems, siteMeta } from '@/mocks/home';

export default function MastheadNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b-2 border-foreground-950 bg-background-50/95 backdrop-blur">
      <div className="flex items-center justify-between gap-4 px-4 py-2.5 md:px-8">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-contrast-2-line text-xl" />
          </div>
          <div className="leading-none">
            <p className="font-label text-[10px] uppercase tracking-[0.3em] text-foreground-500">
              {siteMeta.latinName}
            </p>
            <h1 className="mt-1 font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
              黑料反差
            </h1>
          </div>
        </div>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="站内导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅本期速览
          </a>
          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-foreground-300 text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="grid grid-cols-2 gap-1 border-t border-foreground-950/10 bg-background-100 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="rounded-md px-3 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:bg-background-200"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="col-span-2 mt-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center font-label text-sm font-medium text-background-50"
          >
            订阅本期速览
          </a>
        </nav>
      )}
    </header>
  );
}